import type { PluginDefinition } from "../../types";

export interface PlainMessageConfig {
  message: string;
}

export const PLAIN_MESSAGE_DEFINITION: PluginDefinition<PlainMessageConfig> = {
  subType: "plain_message",
  label: "Plain Message",
  gradeable: false,
  gradingType: "manual",
  defaultConfig: () => ({ message: "" }),
  offeredComponents: () =>
    Promise.resolve([
      {
        label: "Plain Message",
        description: "Fixed text with nothing to submit",
        icon: "fa-comment-o",
      },
    ]),
  loadComponents: () => Promise.all([import("./config/jnctPlainMessageConfig"), import("./student/jnctPlainMessageStudent")]),
};
